import styled, { css } from 'styled-components';

import { COLOR_GRAY_30, COLOR_GRAY_90, COLOR_PURPLE } from 'styles/variables/colors';

export const Container = styled.div`
  width: 100%;
  max-width: 1100px;
  margin: 0 auto;
`;

export const Title = styled.h1`
  margin: 0 0 35px 0;
  font-size: 1.75rem;
`;

export const Header = styled.div`
  padding: 45px 0 0 0;
  background: white;
  border: 1px solid ${COLOR_GRAY_30};
  margin-bottom: 45px;
`;

export const Nav = styled.div``;

export const NavTab = styled.a`
  font-size: 1.125rem;
  color: ${COLOR_GRAY_90};
  text-decoration: none;
  padding: 15px 30px;
  display: inline-block;

  ${(props) =>
    props.isActive &&
    css`
      border-bottom: 3px solid ${COLOR_PURPLE};
      font-weight: 600;
    `}
`;
